import { mq } from '../../../../helpers'
import styled from '@emotion/styled'
import { gsColors } from '../../../../styles/Variables'
import { Section } from '../../../../styles/Components'
import Button from '../components/Button'

export const AddressSection = styled(Section)`
  padding: 25px 0;
  text-align: center;
  margin: 0 0 10px;
  
  ${mq('min', '768px')} { 
    padding: 59px 0 25px;
    margin: 0 auto 30px;
    padding-bottom: 50px;
  }

  .location-svg {
    display: block;
    margin: 0 auto 24px;
    width: 120px;
    height: 120px;
  }

  h2 {
    letter-spacing: 0.28px;

    ${mq('max', '768px')} {
      font-size: 28px !important;
      line-height: 34px;
    }
  }

  h1 {
    font-size: 28px;
    line-height: 1.14;
    letter-spacing: -1px;
    margin: 0 auto 15px;

    ${mq('min', '768px')} {
      font-size: 36px;
      line-height: 0.89;
    }
  }

`

export const MarketsSection = styled.section`
  padding: 0 20px;

  ${mq('max', '768px')} {
    padding: 0 16px;
  }

  .or {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    letter-spacing: -0.57px;
    line-height: 2;
    margin-bottom: 35px;
    text-align: center;
    
    .or-line {
      width: 230px;
      margin: 0 16px;
      border-bottom: 1px solid ${gsColors.lightTangerine};

      ${mq('max', '768px')} {
        width: 100px;
      }
    }

    ${mq('min', '768px')} {
      font-size: 18px;
      margin-bottom: 56px;
    }

    h3 {
      ${mq('max', '768px')} {
        font-size: 16px;
      }
    }
  }

  .markets {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    margin: 0 auto;
    max-width: 1020px;
    gap: 8px;

    ${mq('max', '768xp')} {
      width: 100%;
    }
  }
`

export const MarketButton = styled.button`
  background-color: ${gsColors.white};
  border: ${props => props.active ? `2px solid ${gsColors.sunsetOrange}` : `1px solid ${gsColors.lightTangerine}`};
  color: ${gsColors.black};
  cursor: pointer;
  font-family: Euclid;
  font-weight: 400;
  font-size: 18px;
  letter-spacing: -0.26px;
  margin: 0 6px 20px;
  padding: 18px 16px 14px;
  transition: all 250ms;
  line-height: 100%;
  display: flex;
  height: 54px;
  padding: 14px 50px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  ${mq('max', '768px')} {
    box-sizing: border-box;
    margin: 0;
    display: flex;
    height: 48px;
    // padding: 14px 50px;
    padding: 14px 0;
    width: 50%;
    font-size: 14px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 40%;
    // flex: 1 0 0;
  }

  ${mq('min', '768px')} {
    margin: 0 8px 20px;
  }

  &:hover {
    cursor: pointer;
    border-color: ${gsColors.sunsetOrange};

    // ${mq('min', '768px')} {
    //   transform: translate3d(0, -5px, 0);
    // }
  }

  &:focus {
    // outline: 0;
  }
`

export const DesktopButton = styled(Button)`
  margin: 70px auto 0;
  max-width: 300px;
`

export const PrivacyInfo = styled.div`
position: absolute;
left: 0;
bottom: 50px;
width: 100%;
display: flex;
justify-content: center;
align-items: center;
z-index: 1000;

${mq('max', '768px')} {
  bottom: 30px;
}

a, span, p {
  font-family: Euclid;
  line-height: 27.037px;
  font-size: 14px;
  text-decoration: none;
  color: ${gsColors.meredithGrey} !important;
}

a {
  // color: black;
  // text-decoration: none;

  &:visited {
    color: black;
  }
}

span {
  margin: 0 .5rem;
}
`
